import React, { memo, useCallback } from 'react'

import { BackButton, LogoImage, LogoWrapper } from './header-section-styles'
import { useTranslation } from './../../../hooks/locale'
import { BackIcon } from './../../common/icons'
import { isPlatformAndroidOrIOS } from './../../../utils/platform-utils'
import { HeaderSectionTransport } from './../../../transports/region-landing-page-transport'

type Navigation = HeaderSectionTransport['navigationSectionResponse']['navigation']

interface LogoAreaProps {
    logo: Navigation['logo']
}

const LogoArea: React.FC<LogoAreaProps> = ({ logo }) => {
    const { t } = useTranslation()

    const goBack = useCallback(() => {
        window?.history?.back()
    }, [])

    if (isPlatformAndroidOrIOS) {
        return (
            <BackButton onClick={goBack}>
                <BackIcon alt={t('backIconText')} />
            </BackButton>
        )
    }

    if (!logo?.image?.url) {
        return null
    }

    return (
        <LogoWrapper href={logo.url}>
            <LogoImage src={logo.image ? logo.image.url : ''} alt={'Logo'} />
        </LogoWrapper>
    )
}

export default memo(LogoArea)
